/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Advantages_FootnotesInputs */

const en_homepage_advantages_footnotes = /** @type {(inputs: Homepage_Advantages_FootnotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footnotes`)
};

const es_homepage_advantages_footnotes = /** @type {(inputs: Homepage_Advantages_FootnotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas al pie`)
};

/**
* | output |
* | --- |
* | "Footnotes" |
*
* @param {Homepage_Advantages_FootnotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_advantages_footnotes = /** @type {((inputs?: Homepage_Advantages_FootnotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Advantages_FootnotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_advantages_footnotes(inputs)
	return en_homepage_advantages_footnotes(inputs)
});